import { render, staticRenderFns } from "./SplitReceiver.vue?vue&type=template&id=2a887682&scoped=true"
import script from "./SplitReceiver.vue?vue&type=script&lang=js"
export * from "./SplitReceiver.vue?vue&type=script&lang=js"
import style0 from "./SplitReceiver.vue?vue&type=style&index=0&id=2a887682&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a887682",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a887682')) {
      api.createRecord('2a887682', component.options)
    } else {
      api.reload('2a887682', component.options)
    }
    module.hot.accept("./SplitReceiver.vue?vue&type=template&id=2a887682&scoped=true", function () {
      api.rerender('2a887682', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/data/components/SplitReceiver.vue"
export default component.exports